import axios from 'axios';
import {getCurrentLang} from "./AuthTokenStorage";

import {getToken} from './AuthTokenStorage'
const BASE_URL = 'https://ardakanglass.com/api/v1/';


axios.interceptors.request.use(config => {
    config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers.post['Accept'] = 'application/json';
    const token = getToken();
    
    if (token && config.url.includes("/v1/me")) {
        console.log('token', token);
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.post['Access-Control-Allow-Origin'] = '*';
    }
    return config;
});
//
// axios.interceptors.response.use(response => {
//     return response;
// });
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';


const apiRequestLang = '/' + getCurrentLang();

export function getApi(url, params,withLang=true) {
    if(url == "me" || !withLang){
        return axios({
            method: "GET",
            params: params,
     
            url: BASE_URL + url ,
        });
    }else{
        return axios({
            method: "GET",
            params: params,
     
            url: BASE_URL + url + apiRequestLang,
        });
    }
    
}
export function getWithoutLocalApi(url, params) {
    return axios({
        method: "GET",
        params: params,
        url: BASE_URL + url,
    });
}

export function getApiCustom(url, params) {
    return axios({
        method: "GET",
        params: params,
        paramsSerializer: function (params) {
        },
        url: BASE_URL + url + apiRequestLang,
    });
}

export function postApi(url, data, header = {}) {
    return axios({
        headers: {
            ...header,
        },
        method: "POST",
        data: data,
        url: BASE_URL + url,
    });
}

export function deleteApi(url, data, header = {}) {
    return axios({
        headers: {
            ...header,
        },
        method: "DELETE",
        data: data,
        url: BASE_URL + url,
    });
}

export function putApi(url, data) {
    return axios({
        method: "PUT",
        data: data,
        url: BASE_URL + url,
    });
}

export function postFormApi(url, data, isFile = false) {
    let headers;
    if (isFile) {
        headers = {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ',
        }
    } else {
        headers = {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': 'http://localhost:8080'
        }
    }
    return axios({
        headers: headers,
        method: "POST",
        data: data,
        url: BASE_URL + url,
    }).then(

    );
}

export function postInquiry(url, data, isFile = false) {
    let headers;
    let uploadPercentage;
    if (isFile) {
        headers = {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ',
        }
    } else {
        headers = {
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': 'http://localhost:8080'
        }
    }
    return axios({
        headers: headers,
        onUploadProgress: function (progressEvent) {
            uploadPercentage = Math.round((progressEvent.loaded / progressEvent.total) * 100);

        }.bind(this),
        method: "POST",
        data: data,
        url: BASE_URL + url,
    }).then(

    );
}
